import { render, staticRenderFns } from "./MemberHealth.vue?vue&type=template&id=08b33a5d"
import script from "./MemberHealth.vue?vue&type=script&lang=js"
export * from "./MemberHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports